import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFormRhombus: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFormRhombus"><Path d="M5 12L12 2L19 12L12 22L5 12Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconFormRhombus;
